module.exports = __webpack_public_path__ + "static/media/women-center.491b3eb6.jpg";